import React from 'react';
import { FormWrapper } from './Wrappers';
import TextField from '@mui/material/TextField';
import { genericMemo } from './Types';

const TextAreaInput = genericMemo(FormWrapper(
  {
    Component:
      ({onChange, ...props}: {onChange: (newValue: string) => void}) =>
      <TextField
        {...props}
        multiline
        autoComplete='off'
        onChange={(e) => { onChange(e.target.value) }}
      />,
  }
))

export default TextAreaInput
